import {CloseButton, PinInput, Skeleton} from '@mantine/core'
import {notNullOrEmpty} from 'shared/collection'
import {twMerge} from 'tailwind-merge'
import {match} from 'ts-pattern'

export const CodeInput = ({
  length,
  value,
  onChange,
  disabled,
  mode = 'alpha-num',
  loading,
  className
}: {
  length: number
  value?: string
  onChange: (code: string) => void
  disabled?: boolean
  mode?: 'num' | 'alpha-num'
  loading?: boolean
  className?: string
}) => {
  return (
    <div className={twMerge('flex items-center gap-6', className)}>
      {loading ?
        <Skeleton h='100%' w='100%' />
      : <>
          <PinInput
            size='xl'
            variant='filled'
            length={length}
            value={value}
            onChange={onChange}
            disabled={disabled}
            placeholder=''
            autoFocus
            type={match(mode)
              .with('num', () => 'number' as const)
              .with('alpha-num', () => /[a-zA-Z0-9]$/)
              .exhaustive()}
            classNames={{input: 'font-extrabold'}}
          />
          <CloseButton
            size='lg'
            onClick={() => onChange('')}
            className={notNullOrEmpty(value?.trim()) ? 'invisible' : ''}
          />
        </>
      }
    </div>
  )
}
